module.exports = __webpack_public_path__ + "static/media/PxGroteskScreen.45e57f4e.ttf";